// Thin wrapper around fetch that injects the Shopify session token.
// App Bridge global is loaded via /shopifycloud/app-bridge.js in index.html.
// Window.shopify type is declared in graphql.ts

async function waitForAppBridge(timeout = 10000): Promise<void> {
    if (window.shopify?.idToken) return
    const start = Date.now()
    while (Date.now() - start < timeout) {
        await new Promise(r => setTimeout(r, 100))
        if (window.shopify?.idToken) return
    }
}

async function authHeaders(): Promise<Record<string, string>> {
    await waitForAppBridge()
    const token = await window.shopify?.idToken?.()
    return token ? { Authorization: `Bearer ${token}` } : {}
}

export async function apiGet<T>(path: string): Promise<T> {
    const res = await fetch(path, { headers: await authHeaders() })
    if (!res.ok) throw await toError(res)
    return res.json() as Promise<T>
}

export async function apiPost<T>(path: string, body?: unknown): Promise<T> {
    const res = await fetch(path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...(await authHeaders()) },
        body: body !== undefined ? JSON.stringify(body) : undefined,
    })
    if (!res.ok) throw await toError(res)
    return res.json() as Promise<T>
}

async function toError(res: Response): Promise<Error> {
    const data = await res.json().catch(() => ({}))
    const err = new Error(data.error || `HTTP ${res.status}`)
    ;(err as any).status = res.status
    ;(err as any).details = data.details
    return err
}
